export default {
    name: 'TDIC',
    prefix: 'tdic',
    rootStyle: {
        '--GW-FONT-FAMILY': '"Open Sans", sans-serif',
        '--TDIC-BRAND-PRIMARY-RED': '#B32317',
        '--TDIC-BRAND-PRIMARY-ORANGE': '#EF8200',
        '--TDIC-BRAND-PRIMARY-GREY': '#747679',
        '--TDIC-BRAND-PRIMARY-GREEN': '#98D856',
        '--TDIC-BRAND-PRIMARY-YELLOW': '#FFE57D',
        '--TDIC-BRAND-SECONDARY-TEAL': '#00707A',
        '--TDIC-BRAND-PRIMARY-TEAL': '#007D89',
        '--TDIC-BRAND-TERTIARY-BLACK': '#241C15',
        '--TDIC-BRAND-SECONDARY-DARKBLUE': '#18455B',
        '--TDIC-BRAND-SECONDARY-BLUE': '#2C5975',
        '--TDIC-BRAND-SUPPORT-WHITE': '#FFFFFF',
        '--TDIC-BRAND-SUPPORT-LIGHTEST-GREY': '#F8F8F8',
        '--TDIC-BRAND-SUPPORT-LIGHT-GREY': '#F5F5F5',
        '--TDIC-BRAND-SUPPORT-GREY': '#CBCBCB',
        '--TDIC-BRAND-SUPPORT-DARK-GREY': '#515151',
        '--TDIC-BRAND-SUPPORT-LIGHT-ORANGE': '#FDE9D1',
        '--TDIC-BRAND-SUPPORT-LIGHT-RED': '#F4DEDC',
        '--TDIC-BRAND-LINK-COLOR-BLUE': '#2769EF',
        '--TDIC-BRAND-SUPPORT-LINK-TEXT-GREY': '#1B1C1D99',
        '--TDIC-BRAND-SUPPORT-INFO-BLUE': '#C3DDEC',
        '--TDIC-BRAND-SUPPORT-REQUIRED-RED': '#FF0000',
        '--TDIC-BRAND-SUPPORT-FOCUS-BLUE': '#1E9ACF',
        '--TDIC-BRAND-SUPPORT-DARK-BLUE': '#244C5B',
        '--TDIC-BRAND-SUPPORT-BLUE': '#2C5975',
        '--TDIC-BRAND-SUPPORT-ORANGE': '#EF8200',
        '--TDIC-BRAND-SUPPORT-SUCCESS': '#469156',
        '--TDIC-BRAND-SUPPORT-ERROR': '#D8222E',
        '--TDIC-BRAND-PRODUCT-CSL': '#750A13',
        '--TDIC-BRAND-PRODUCT-PL': '#EF8200',
        '--TDIC-BRAND-PRODUCT-DISABLITY': '#367B27',
        '--TDIC-BRAND-PRODUCT-CP': '#18A4AE',
        '--TDIC-BRAND-PRODUCT-WC': '#244C5B',

        // Global FONT SIZES
        '--TDIC-BRAND-FONT-SIZE-XS': '12px',
        '--TDIC-BRAND-FONT-SIZE-SM': '14px',
        '--TDIC-BRAND-FONT-SIZE-S': '15px',
        '--TDIC-BRAND-FONT-SIZE': '16px',
        '--TDIC-BRAND-FONT-SIZE-MD': '20px',
        '--TDIC-BRAND-FONT-SIZE-LG': '24px',
        '--TDIC-BRAND-FONT-SIZE-XL': '32px',
        '--TDIC-BRAND-FONT-SIZE-XXL': '40px',
        '--TDIC-BRAND-FONT-SIZE-XXXL': '56px',

        // Global FONT WEIGHTS
        '--TDIC-BRAND-FONT-WEIGHT-THIN': '100',
        '--TDIC-BRAND-FONT-WEIGHT-SEMI-BOLD': '200',
        '--TDIC-BRAND-FONT-WEIGHT-LIGHT': '300',
        '--TDIC-BRAND-FONT-WEIGHT-REGULAR': '400',
        '--TDIC-BRAND-FONT-WEIGHT-MEDIUM': '500',
        '--TDIC-BRAND-FONT-WEIGHT-EXTRA-LIGHT': '600',
        '--TDIC-BRAND-FONT-WEIGHT-BOLD': '700',
        '--TDIC-BRAND-FONT-WEIGHT-EXTRA-BOLD': '800',
        '--TDIC-BRAND-FONT-WEIGHT-EXTRA-BLACK': '900',

        // Global LINE HEIGHT
        '--TDIC-BRAND-LINE-HEIGHT-XXXXXXL': '110px',
        '--TDIC-BRAND-LINE-HEIGHT-XXXXXL': '95px',
        '--TDIC-BRAND-LINE-HEIGHT-XXXXL': '112px',
        '--TDIC-BRAND-LINE-HEIGHT-XXXL': '48px',
        '--TDIC-BRAND-LINE-HEIGHT-XXL': '40px',
        '--TDIC-BRAND-LINE-HEIGHT-XL': '35px',
        '--TDIC-BRAND-LINE-HEIGHT-L': '30px',
        '--TDIC-BRAND-LINE-HEIGHT-M': '24px',
        '--TDIC-BRAND-LINE-HEIGHT-S': '18px',
        '--TDIC-BRAND-LINE-HEIGHT-XS': '10px',

        // Spacing variables
        '--TDIC-BRAND-SPACING-XXS': '4px',
        '--TDIC-BRAND-SPACING-XS': '8px',
        '--TDIC-BRAND-SPACING-SM': '12px',
        '--TDIC-BRAND-SPACING': '16px',
        '--TDIC-BRAND-SPACING-LG': '20px',
        '--TDIC-BRAND-SPACING-XL': '24px',
        '--TDIC-BRAND-SPACING-XXL': '32px',
        '--TDIC-BRAND-SPACING-XXXL': '40px',

        // Border variables
        '--TDIC-BRAND-BORDER-WIDTH-THIN': '1px',
        '--TDIC-BRAND-BORDER-WIDTH': '2px',
        '--TDIC-BRAND-BORDER-WIDTH-THICK': '0px',

        // Typography
        '--TDIC-BRAND-FONT-SIZE-H1': '44px',
        '--TDIC-BRAND-FONT-SIZE-H5': '18px',

        '--GW-COLOR-BRAND-1': 'var(--TDIC-BRAND-PRIMARY-RED)',
        '--GW-COLOR-BRAND-1-HOVER': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
        '--GW-COLOR-BRAND-1-ACTIVE': 'var(--TDIC-BRAND-PRIMARY-RED)',
        '--GW-COLOR-DARK-CONTRAST': 'var(--TDIC-BRAND-SUPPORT-LIGHTEST-GREY)',
        '--GW-COLOR-BRAND-2': 'var(--TDIC-BRAND-PRIMARY-RED)',
        '--GW-COLOR-LINK-1': 'var(--TDIC-BRAND-PRIMARY-TEAL)',
        '--GW-COLOR-BRAND-3': 'var(--TDIC-BRAND-PRIMARY-RED)',
        '--GW-COLOR-HIGHLIGHT-2': 'var(--TDIC-BRAND-SUPPORT-LIGHT-GREY)',
        '--GW-COLOR-LINK-1-HOVER': 'var(--TDIC-BRAND-LINK-COLOR-BLUE)',
        '--GW-COLOR-LINK-1-ACTIVE': 'var(--TDIC-BRAND-LINK-COLOR-BLUE)',
        '--GW-FONT-SIZE-XS': 'var(--TDIC-BRAND-FONT-SIZE-XS)',
        '--GW-FONT-SIZE-SM': 'var(--TDIC-BRAND-FONT-SIZE-SM)',
        '--GW-FONT-SIZE': 'var(--TDIC-BRAND-FONT-SIZE)',
        '--GW-FONT-SIZE-MD': 'var(--TDIC-BRAND-FONT-SIZE-MD)',
        '--GW-FONT-SIZE-LG': 'var(--TDIC-BRAND-FONT-SIZE-LG)',
        '--GW-FONT-SIZE-XL': 'var(--TDIC-BRAND-FONT-SIZE-XL)',
        '--GW-FONT-SIZE-XXL': 'var(--TDIC-BRAND-FONT-SIZE-XXL)',
        '--GW-FONT-SIZE-XXXL': 'var(--TDIC-BRAND-FONT-SIZE-XXXL)',
        '--GW-FONT-WEIGHT-THIN': 'var(--TDIC-BRAND-FONT-WEIGHT-THIN)',
        '--GW-FONT-WEIGHT-SEMI-BOLD': 'var(--TDIC-BRAND-FONT-WEIGHT-SEMI-BOLD)',
        '--GW-FONT-WEIGHT-EXTRA-LIGHT': 'var(--TDIC-BRAND-FONT-WEIGHT-EXTRA-LIGHT)',
        '--GW-FONT-WEIGHT-LIGHT': 'var(--TDIC-BRAND-FONT-WEIGHT-LIGHT)',
        '--GW-FONT-WEIGHT-REGULAR': 'var(--TDIC-BRAND-FONT-WEIGHT-REGULAR)',
        '--GW-FONT-WEIGHT-MEDIUM': 'var(--TDIC-BRAND-FONT-WEIGHT-MEDIUM)',
        '--GW-FONT-WEIGHT-BOLD': 'var(--TDIC-BRAND-FONT-WEIGHT-BOLD)',
        '--GW-FONT-WEIGHT-EXTRA-BOLD': 'var(--TDIC-BRAND-FONT-WEIGHT-EXTRA-BOLD)',
        '--GW-FONT-WEIGHT-BLACK': 'var(--TDIC-BRAND-FONT-WEIGHT-EXTRA-BLACK)',
        '--GW-SPACING-XXS': 'var(--TDIC-BRAND-SPACING-XXS)',
        '--GW-SPACING-XS': 'var(--TDIC-BRAND-SPACING-XS)',
        '--GW-SPACING-SM': 'var(--TDIC-BRAND-SPACING-SM)',
        '--GW-SPACING': 'var(--TDIC-BRAND-SPACING)',
        '--GW-SPACING-LG': 'var(--TDIC-BRAND-SPACING-LG)',
        '--GW-SPACING-XL': 'var(--TDIC-BRAND-SPACING-XL)',
        '--GW-SPACING-XXL': 'var(--TDIC-BRAND-SPACING-XXL)',
        '--GW-SPACING-XXXL': 'var(--TDIC-BRAND-SPACING-XXXL)',
        '--GW-BORDER-WIDTH-THIN': 'var(--TDIC-BRAND-BORDER-WIDTH-THIN)',
        '--GW-BORDER-WIDTH': 'var(--TDIC-BRAND-BORDER-WIDTH)',
        '--GW-BORDER-WIDTH-THICK': 'var(--TDIC-BRAND-BORDER-WIDTH-THICK)',
        '--GW-BORDER-RADIUS': 'var(--TDIC-BRAND-BORDER-WIDTH-THICK)',
        '--GW-BOX-SHADOW-FOCUS-1-COLOR': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
        '--GW-BOX-SHADOW-FOCUS-INNER-1': 'var(--TDIC-BRAND-SUPPORT-DARK-GREY)',
        '--GW-BOX-SHADOW-FOCUS-OUTER': 'var(--TDIC-BRAND-SUPPORT-DARK-GREY)',

        '--tdic-inline-notification-info-bg-color': '#F2F8FF',
        '--tdic-inline-notification-info-border-color': '#86AFFF',
        '--tdic-inline-notification-error-bg-color': '#FFF0F1',
        '--tdic-inline-notification-error-border-color': '#D8222E',
        '--tdic-inline-notification-warning-bg-color': '#FFF8E2',
        '--tdic-inline-notification-warning-border-color': '#EF8200',
        '--tdic-inline-notification-success-bg-color': '#E2EEE5',
        '--tdic-inline-notification-success-border-color': '#469156'
    },
    componentStyles: {
        Button: {
            button: {
                '--button-border-radius': '0px',
                '--button-border': 'solid 1px',
                '--button-box-shadow': 'none',
                '--button-width': '150px',
                '--button-height': '40px',
                '--button-font-weight': '600'
            },
            primary: {
                '--button-bg-image': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-hover-bg-image': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--button-active-bg-image': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--button-focus-bg-image': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--button-color': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--button-hover-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-active-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-focus-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-border-color': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-hover-border-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-active-border-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-focus-border-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-hover-bg-color': 'var(--button-hover-bg-image)',
                '--button-active-bg-color': 'var(--button-active-bg-image)',
                '--button-focus-bg-color': 'var(--button-focus-bg-image)'
            },
            secondary: {
                '--button-active-bg-image': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-focus-bg-image': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-hover-bg-image': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-bg-color': 'var(--GW-COLOR-BRAND-1-HOVER)',
                '--button-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-border-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-hover-bg-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-hover-color': 'var(--GW-COLOR-BRAND-1-HOVER)',
                '--button-hover-border-color': 'var(--GW-COLOR-BRAND-1)',
                '--button-focus-bg-color': 'var(--button-focus-bg-image)',
                '--button-active-bg-color': 'var(--button-active-bg-image)'
            },
            tertiary: {
                '--button-bg-image': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--button-hover-bg-image': 'var(--TDIC-BRAND-SUPPORT-LIGHT-RED)',
                '--button-active-bg-image': 'var(--TDIC-BRAND-SUPPORT-LIGHT-RED)',
                '--button-focus-bg-image': 'var(--TDIC-BRAND-SUPPORT-LIGHT-RED)',
                '--button-color': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-hover-color': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-active-color': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-focus-color': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--button-border-color': 'var(--button-bg-color)',
                '--button-hover-border-color': 'var(--TDIC-BRAND-SUPPORT-LIGHT-RED)',
                '--button-active-border-color': 'var(--TDIC-BRAND-SUPPORT-LIGHT-RED)',
                '--button-focus-border-color': 'var--TDIC-BRAND-SUPPORT-LIGHT-RED)',
                '--button-hover-bg-color': 'var(--button-hover-bg-image)',
                '--button-active-bg-color': 'var(--button-active-bg-image)',
                '--button-focus-bg-color': 'var(--button-focus-bg-image)'
            },
            disabled: {
                '--button-disabled-opacity': '40%',
                'pointer-events': 'none'
            },
        },
        ApplicationHeader: {
            applicationHeaderWrapper: {
                position: 'sticky',
                top: 0,
                left: 0,
                'z-index': 9999
            }
        },
        Avatar: {
            avatar: {
                '--avatar-border-color': 'var(--TDIC-BRAND-SUPPORT-LIGHT-GREY)',
                '--avatar-bg-color': 'var(--TDIC-BRAND-SUPPORT-LIGHT-ORANGE)',
                '--avatar-bg-color-hover': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--avatar-bg-color-active': 'var(--TDIC-BRAND-SUPPORT-LIGHT-ORANGE)',
                '--avatar-color': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--avatar-color-hover': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--avatar-color-active': 'var(--TDIC-BRAND-PRIMARY-RED)',
                '--avatar-font-size': 'var(--GW-FONT-SIZE-SM)',
                '--avatar-overlay-bg-color': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--avatar-overlay-opacity-hover': '0',
                border: 'var(--avatar-border)',
            },
        },
        Input: {
            input: {
                '--input-bg-color': 'var(--TDIC-BRAND-SUPPORT-WHITE)',
                '--input-border-color': 'var(--TDIC-BRAND-SUPPORT-GREY)',
                '--input-border-radius': '0'
            }
        },
        Checkbox: {
            checkbox: {
                '--checkbox-border-radius': '0',
                '--checkbox-color': 'var(--TDIC-BRAND-SECONDARY-DARKBLUE)',
                '--checkbox-border-color': 'var(--TDIC-BRAND-SUPPORT-DARK-GREY)'
            }
        },
        DropdownSelect: {
            dropdownSelect: {
                '--generic-select-control-border-radius': '0',
                '--generic-select-control-border-color': 'var(--TDIC-BRAND-SUPPORT-GREY)'
            }
        },
        RadioButton: {
            radioButton: {
                '--radio-button-icon-border': '1px solid var(--TDIC-BRAND-SUPPORT-DARK-GREY)',
                '--radio-button-icon-checked-border': '1px solid var(--TDIC-BRAND-SECONDARY-DARKBLUE);',
                '--radio-button-icon-focus-border': '1px solid var(--TDIC-BRAND-SECONDARY-DARKBLUE)'
            }
        },
        GenericSelectControl: {
            optionFocused: {
                '--generic-select-option-hover-bg-color': 'var(--TDIC-BRAND-SUPPORT-LIGHT-GREY)',
            },
            optionSelected: {
                '--generic-select-option-selected-bg-color': 'var(--TDIC-BRAND-SUPPORT-LIGHT-GREY)'
            }
        },
        InfoLabel: {
            infoLabel: {
                '--GW-COLOR-HIGHLIGHT-2-ACTIVE': 'var(--TDIC-BRAND-SUPPORT-INFO-BLUE)'
            },
            icon: {
                '--info-label-font-size': 'var(--TDIC-BRAND-FONT-SIZE-MD)'
            }
        },
        Toggle: {
            toggle: {
                '--GW-BORDER-RADIUS': '0',
                '--GW-COLOR-BORDER': 'var(--TDIC-BRAND-SUPPORT-GREY)'
            }
        },
        InputMask: {
            inputMask: {
                '--input-border-radius': '0',
                '--input-border-color': 'var(--TDIC-BRAND-SUPPORT-GREY)'
            }
        },
        CurrencyField: {
            currency: {
                '--input-border-radius': '0',
                '--input-border-color': 'var(--TDIC-BRAND-SUPPORT-GREY)'
            }
        },
        Table: {
            table: {
                '--table-color': 'var(--TDIC-BRAND-SUPPORT-DARK-GREY)'
            }
        },
        TopNavigation: {
            topNavigation: {
                '--nav-item-padding-top': 'calc(var(--GW-SPACING-SM) - 2px)',
                '--nav-item-fonts-size': 'var(--TDIC-BRAND-FONT-SIZE-SM)'
            }
        },
        InlineNotification: {
            inlineNotification: {
                '--inline-notification-margin-bottom': '1rem',
                '--inline-notification-border-radius': '0',
                '--inline-notification-color': 'var(--TDIC-BRAND-TERTIARY-BLACK)',
                '--inline-notification-font-size': 'var(--GW-FONT-SIZE)',
                'margin-bottom': 'var(--inline-notification-margin-bottom)',
                'border-width': '1px',
                'border-style': 'solid'
            },
            inlineNotificationInfo: {
                '--inline-notification-bg-color': 'var(--tdic-inline-notification-info-bg-color)',
                '--inline-notification-border-color': 'var(--tdic-inline-notification-info-border-color)'
            },
            inlineNotificationError: {
                '--inline-notification-bg-color': 'var(--tdic-inline-notification-error-bg-color)',
                '--inline-notification-border-color': 'var(--tdic-inline-notification-error-border-color)'
            },
            inlineNotificationSuccess: {
                '--inline-notification-bg-color': 'var(--tdic-inline-notification-success-bg-color)',
                '--inline-notification-border-color': 'var(--tdic-inline-notification-success-border-color)'
            },
            inlineNotificationWarning: {
                '--inline-notification-bg-color': 'var(--tdic-inline-notification-warning-bg-color)',
                '--inline-notification-border-color': 'var(--tdic-inline-notification-warning-border-color)'
            }
        },
        Link: {
            link: {
                '--link-color': 'var(--TDIC-BRAND-SECONDARY-TEAL)',
                '--link-opacity-disabled': '50%',
                '--link-font-size': 'var(--GW-FONT-SIZE)',
                'font-weight': '600'
            }
        },
        Loader: {
            text: {
                'var(--loader-text-font-size)': 'var(--TDIC-BRAND-FONT-SIZE-MD)',
                'font-weight': 'var(--TDIC-BRAND-FONT-WEIGHT-BOLD)'
            }
        }
    }
};
